// extracted by mini-css-extract-plugin
module.exports = {"home":"Departments_home__3xdnx","textFields":"Departments_textFields__2G5cV","actionButton":"Departments_actionButton__Bju4j","error":"Departments_error__2ptOi"};